import { GROUPS, PREFIX } from '@/service/apiConf';
import { get } from '@/service/request';

import type { NetworkListResponse, NetworkQueryParams } from './types';

/** 拉取 VPC 列表；需传 ws 租户参数 */
export function getNetworkVpcs(params?: NetworkQueryParams): Promise<NetworkListResponse> {
  const { ws, dc, ...rest } = params ?? {};
  const query: Record<string, unknown> = { ...rest };
  if (ws) query.ws = ws;
  return get(`${PREFIX.vapis_v1_dc_ws(GROUPS.network, dc)}/all-vpcs`, query);
}

/** 按 VPC 拉取安全组列表 */
export function getNetworkSecurityGroups(vpc: string, params?: Pick<NetworkQueryParams, 'ws' | 'dc'>): Promise<NetworkListResponse> {
  const { ws, dc } = params ?? {};
  const query: Record<string, unknown> = {};
  if (ws) query.ws = ws;
  return get(`${PREFIX.vapis_v1_dc_ws(GROUPS.network, dc)}/vpcs/${vpc}/all-securitygroups`, query);
}
